enum NewsSignalSubType {
    Leadership = "Leadership",
    Growth = "Growth",
    Strategy = "Strategy",
    Investment = "Investment",
    CompanyChallenges = "CompanyChallenges",
    Recognition = "Recognition",
    AnyNews = "AnyNews",
}

export default NewsSignalSubType;
